import '~/js/views/general/includes/scroll-below';
import ToursList from '~/js/views/general/components/tours/ToursList';
import Spinner from '~/js/components/Spinner';
import GoFetch from '~/js/modules/fetch-wrapper.js';

const fetch = new GoFetch();
const $resortSelect = $('#js-resort-select');
const $toursList = query('#tours-list');
const $spinnerHolder = query('#spinner-holder');
const loadResort = {
    value: sessionStorage.getItem('loadResortCode'),
    label: sessionStorage.getItem('loadResortName')
};

const selectHandler = (event, {item}) => {
    const element = item || loadResort;

    sessionStorage.removeItem('loadResortCode');
    sessionStorage.removeItem('loadResortName');
    if(element && element.value && element.label) {
        ReactDOM.unmountComponentAtNode($toursList);
        ReactDOM.render(<Spinner />, $spinnerHolder);
        fetch.post('/events/getTours/', null, {
            rstCode: element.value
        }).then((response) => {
            ReactDOM.unmountComponentAtNode($spinnerHolder);
            ReactDOM.render(<ToursList data={response.data.events} resortName={element.label} />, $toursList);
        }).catch((response) => {
            console.error(response);
        });
    }
};

if(loadResort && loadResort.value) {
    $resortSelect.val(loadResort.value);
    window.scrollTo(0, $('#toursControls').offset().top);
}

// Initialization selectmenu
$resortSelect.selectmenu({
    appendTo: $resortSelect.parent(),
    select: selectHandler,
    create: selectHandler
});

//  link to option resort
const selectMenu = document.querySelector('#js-resort-select');
const selectModulMenu = document.querySelector('#js-resort-select-menu');
const selectModulButton = document.querySelector('#js-resort-select-button');

//  title resorts
selectModulButton.addEventListener('click', () => {
    for(let i = 0; i < selectMenu.children.length; i++) {
        if(!selectMenu.children[i].dataset.href) {
            selectModulMenu.children[i].classList.add('ui-selectmenu-optgroup');
            selectModulMenu.children[i].children[0].classList.remove('ui-menu-item-wrapper');
        }
        if(!selectMenu.children[i].dataset.href && i > 0) {
            selectModulMenu.children[i].classList.remove('ui-menu-item');
        }
    }
});
